import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
  zIndexLayers,
} from '../styles';
import { Container, StructuredText } from './ui';
import { hasStructuredText } from '../utils';

const StyledSitewideNotice = styled.div`
  padding: 10px 0;
  text-align: center;
  background-color: ${brandColours.octonary};
  z-index: ${zIndexLayers.fourth};
  position: relative;
`;

const StyledText = styled.div`
  p {
    color: ${standardColours.white};
    font-weight: ${fontWeights.semibold};
    ${fontSize(13)};

    ${minBreakpointQuery.small`
      ${fontSize(14)};
    `}

    ${minBreakpointQuery.large`
      ${fontSize(15)};
    `}

    a {
      text-decoration: underline;
    }
  }
`;

const SitewideNotice = () => {
  const {
    datoCmsHeader: { sitewideNotice },
  } = useStaticQuery(graphql`
    query SitewideNoticeQuery {
      datoCmsHeader {
        sitewideNotice {
          value
          links {
            id: originalId
            text
            pageUrl {
              ...LinkFragment
            }
          }
        }
      }
    }
  `);

  return (
    hasStructuredText(sitewideNotice) && (
      <StyledSitewideNotice>
        <Container>
          <StyledText>
            <StructuredText data={sitewideNotice} />
          </StyledText>
        </Container>
      </StyledSitewideNotice>
    )
  );
};

export default SitewideNotice;
